let modalIndex = 0;

function modalIncrease() {
    modalIndex++;
}

export {modalIndex, modalIncrease};


// WEBPACK FOOTER //
// ./components/Modal/q.js